import { render, staticRenderFns } from "./AddRegionComponent.vue?vue&type=template&id=55c9b164&"
import script from "./AddRegionComponent.vue?vue&type=script&lang=js&"
export * from "./AddRegionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports